import { API_URL } from '../../constants';
import fetchAuthorization from '../fetchAuthorization';

export async function deleteClub(deletedClub: number | null): Promise<any> {
  try {
    return await fetchAuthorization(`${API_URL}member_follows?row_num=${deletedClub!}`, {
      method: 'DELETE',
    });
  } catch (e: any) {
    throw new Error(`Unable to delete university. Error message: ${e.message}`);
  }
}
